import styled from "styled-components";

export const Center = styled.div`
  margin: 1.5% 1%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  border-radius: 17px;
  width: 450px;
  form {
    display: flex;
    flex-direction: column;
  }
`;
export const Background = styled.div`
  background-color: #EFEFEF;
  width: 100%;
  height: 100vh;
  background-size: cover;
`;
export const Layout = styled.div`
  display: flex;
  justify-content: center;
  height: 80%;
  align-items: center;
`;
export const H1 = styled.h2`
    font-family: 'Open Sans', sans-serif;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
`;

export const Logo = styled.img`
width: 20%;
padding: 5%;
`;
export const Div = styled.div`
width: 78%;
padding: 2%;
margin-left: 10%;
`;
export const DivSenha = styled.div`

padding: 2%;
`;
export const A = styled.a`
text-align: center;

font-size: 15px;

opacity: 0.8;

color: #23527C;

text-decoration: none;
`;
